// extracted by mini-css-extract-plugin
export default {"navRelatorios":"Relatorios_navRelatorios__IGq2I"};